var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { Box } from '@mui/material';
var disclaimerText = 'We independently publish plant data to search multiple nurseries at once. We may earn a commission on qualifying purchases when you buy through our links.';
var defaultStyles = function (theme) { return ({
    fontFamily: 'system-ui, sans-serif',
    fontSize: 16,
    fontStyle: 'italic',
    fontWeight: 400,
    lineHeight: '32px',
    letterSpacing: '0.06em',
    textAlign: 'center',
    padding: theme.spacing(2.5, 0),
}); };
export default function Disclaimer(_a) {
    var sx = _a.sx;
    return (React.createElement(Box, { sx: __spreadArray([defaultStyles], (Array.isArray(sx) ? sx : [sx]), true) }, disclaimerText));
}
